/* COMPONENTS */
import AboutBanner from "components/about/banner";
import StoryLine from "components/about/storyline";
import AboutTeam from "components/about/team";
import CallToAction from "components/common/cta";

const AboutUs = () => {
  return (
    <section className="p-0">
      {/* BANNER */}
      <AboutBanner />

      {/* STORYLINE */}
      <StoryLine />

      {/* TEAM */}
      <AboutTeam />

      {/* CALL TO ACTION */}
      <CallToAction />
    </section>
  );
};

export default AboutUs;
